export default "__VITE_ASSET__721de522__"